export default __webpack_public_path__ + "static/media/pila-de-combustible.68a48433.jpg";